import React from 'react'
import { Radio } from '@roo/roo'
import RegionDatePicker from '@/components/RegionDatePicker'
import { EndTimeTypeEnum } from '../utils'
import { useTranslation } from '@sailor/i18n-web'
import dayjs from 'dayjs'
import { isEqualString } from '@/common/utils'

interface EndTime {
  time?: number;
  type: 1 | 2;
}

interface EndDateFormItemProps {
  value?: EndTime;
  disabled?: boolean
  onChange?: (value: EndTime) => void;
  disabledDate:  ((date: dayjs.Dayjs) => boolean) | undefined
}

const EndDateFormItem: React.FC<EndDateFormItemProps> = (props) => {
  const { value = { type: 2 }, onChange = () => {}, disabledDate } = props
  const { t } = useTranslation()
  const handleTypeChange = (newType: any) => {
    onChange({ ...value, type: Number(newType) as any })
  }

  const handleTimeChange = (date: any) => {
    const newTime = date ? date.valueOf() : undefined
    onChange({ ...value, time: newTime })
  }

  return (
    <div>
      <Radio.Group value={String(value.type)} onChange={handleTypeChange} disabled={props.disabled}>
        <Radio value={String(EndTimeTypeEnum.PERMANENT)}>{t('e_pc_long_term', '长期有效')}</Radio>
        <Radio value={String(EndTimeTypeEnum.CUSTOM)}>{t('e_pc_custom', '自定义')}</Radio>
      </Radio.Group>
      {isEqualString(value.type, 1) && (
        <div style={{ paddingTop: '8px' }}>
          <RegionDatePicker value={value.time} onChange={handleTimeChange} disabledDate={disabledDate} disabled={props.disabled}/>
        </div>
      )}
    </div>
  )
}

export default EndDateFormItem
